import { compress } from "micro-graphql-react"

export default compress`
  fragment StudentFields on Student {
    id
    createdAt
    fullName
    showPath
    safeEmail
    phoneNumber
    parentName
    parentEmail
    parentPhoneNumber
    school {
      name
    }
    grade {
      name
    }
  }
`
